import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardApiIsomorphicFetchCredits } from '#/modules/orgDashboard/api/orgDashboardApiFetchCredits';
import { orgDashboardListCreditsRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardListCreditsPageLoadable } from './OrgDashboardListCreditsPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardListCreditsRoute>) {
  const [{ packs, promoCredits, membershipPromoCredits }] = await Promise.all([
    orgDashboardApiIsomorphicFetchCredits({ request, context })(orgId),
    OrgDashboardListCreditsPageLoadable.load(),
  ]);

  return { packs, promoCredits, membershipPromoCredits };
}

export default function OrgDashboardListCreditsHorizonRoute({
  loaderData: { packs, promoCredits, membershipPromoCredits },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Credits')}>
      <OrgDashboardListCreditsPageLoadable
        packs={packs}
        promoCredits={promoCredits}
        membershipPromoCredits={membershipPromoCredits}
      />
    </RouteModule>
  );
}
